var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dsf_search_column" }, [
    _c(
      "div",
      {
        staticClass: "item_inner",
        on: {
          click: function ($event) {
            return _vm.toDetail(_vm.data)
          },
        },
      },
      [
        _c(
          "div",
          { staticClass: "item-left-img" },
          [
            _c("dsf-image", {
              attrs: {
                src: _vm._f("imgFormat")(_vm.data["cover"]),
                "error-src": _vm.dsf.config.setting_nc_image_default_img,
              },
            }),
            _c("span", { staticClass: "item-type" }, [
              _vm._v(_vm._s(_vm.data.typename || "直播")),
            ]),
          ],
          1
        ),
        _c("div", { staticClass: "item-right-desc" }, [
          _c("div", { staticClass: "title" }, [
            _c("span", { staticClass: "name ellipsis-2" }, [
              _vm._v(_vm._s(_vm.data.title)),
            ]),
          ]),
          _c("p", { staticClass: "item-exam-rule" }),
          _c("ul", { staticClass: "item-bottom-desc" }),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }